'use strict';

module.exports = Odigeo.Model.extend({
    defaults: {
        pieces: 0,
        kilos: 0,
        price: 0,
        primePrice: 0,
        isIncludedBaggage: false,
        isSelectableBaggage: false,
        selected: false,
        idPassenger: -1,
        idRow: '',
    },
    getDescriptor: function() {
        return Odigeo._.pick(this.getAll(), 'pieces', 'kilos', 'price', 'primePrice');
    },
});
